import mapActions from './mapActions';

export default mapActions('operations_employees_list', {
    fetchAll_url: data => `/api/work_operations/list/${data.year}/${data.month}`
});